import React from 'react';

interface DialogTitleProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

/**
 * DialogTitle component for use with Dialog
 */
const DialogTitle: React.FC<DialogTitleProps> = ({
  children,
  className = '',
  id = 'dialog-title',
}) => {
  return (
    <div className="px-6 pt-6 pb-3">
      <h3
        className={`text-lg font-medium leading-6 text-gray-900 dark:text-white ${className}`}
        id={id}
      >
        {children}
      </h3>
    </div>
  );
};

export default DialogTitle;